import { DependencyList, useEffect } from 'react';
import { useSetState } from 'react-use';
import { Icon, Tabs } from '@ts/storybook';
import { get, remove, sortBy } from 'lodash';
import { addNewFlavorTabs } from '../flavor.utils';
import { CElementType, CEntity, IForm } from '@ts/ui-models';

interface IItemTypeFormProps extends IForm {}

const ItemTypeForm = (props: IItemTypeFormProps) => {
  const { values } = props;
  const [state, setState] = useSetState<{ tabs: any[]; selectedTab: number }>({ tabs: [], selectedTab: 0 });

  //#region Handlers
  const handleSelectTab = (_event, value) => {
    setState({ selectedTab: value });
  };

  const changeHandler = attrName => callbackArg => {
    const value = get(callbackArg, 'target.value', callbackArg);
    const currentTab: any = state.tabs[state.selectedTab];
    if (!currentTab) return null;

    const currentFlavor = currentTab.flavor;
    if (currentFlavor === 'element') {
      // update in root of values
      props.onChange(`${attrName}`, value);
    } else {
      // update flavor object in values.flavors
      props.onChange(`flavors.${currentFlavor}.${attrName}`, value);
    }
  };
  const onChangeTabs = (modifiedTabs, type) => {
    let value;
    if (type === 'add') value = { isAlive: true };
    else {
      if (props.mode === 'edit') value = { isAlive: false };
      else value = null;
    }

    props.onChange(`flavors.${modifiedTabs[0].flavor}`, value);
  };

  //#endregion

  //#region Functions
  const generateTabs = (tab, i) => {
    let iconComponent = tab.icon ? <Icon icon={tab.icon} /> : undefined;
    return {
      label: tab.label,
      icon: iconComponent,
      value: i,
      disabled: tab.fnDisabled && tab.fnDisabled(props),
    };
  };

  const getTabValues = () => {
    const valuesRoot = props.values;
    const currentTab: any = state.tabs[state.selectedTab];
    if (!currentTab) return null;

    const currentFlavor = currentTab.flavor;
    if (currentFlavor == 'element') return new CElementType(valuesRoot);
    const flavorValues = get(valuesRoot, `flavors.${currentFlavor}`, {});
    return new CEntity(flavorValues);
  };
  //#endregio

  //#region Effects
  const effectGenerateTabs = (deps: DependencyList) => {
    useEffect(() => {
      let tabs = addNewFlavorTabs('itemType', [], 'element');
      // Flavors tabs
      if (values && values.flavors) {
        Object.keys(values.flavors).map(flavor => {
          if (flavor === 'device' || flavor === 'location' || flavor === 'process') {
            tabs = addNewFlavorTabs('itemType', tabs, `${flavor}`);
          }
        });
      }

      // in mode new, remove auxiliary tabs
      if (props.mode == 'new') {
        remove(tabs, { isAux: true });
      }
      // order the tabs
      tabs = sortBy(tabs, 'order');

      setState({
        tabs,
        selectedTab: state.selectedTab >= tabs.length ? 0 : state.selectedTab || 0,
      });
    }, deps);
  };

  //#endregion

  effectGenerateTabs([JSON.stringify(values?.flavors)]);

  const tabSelected = state.tabs[state.selectedTab];
  if (!tabSelected) return;
  const InnerForm = tabSelected.content;

  return (
    <Tabs
      id="itemType-form-tabs"
      justifyContent="flex-start"
      value={state.selectedTab}
      onChange={handleSelectTab}
      tabs={state.tabs.map((tab, i) => generateTabs(tab, i))}
    >
      <InnerForm
        {...props}
        values={getTabValues()}
        onChange={(attr, value) => changeHandler(attr)(value)}
        onCallbackChange={changeHandler}
        onChangeTabs={onChangeTabs}
        isItemType
      />
    </Tabs>
  );
};

export default ItemTypeForm;
